/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setupaccountchoosepassword3Inputs */

const en_setupaccountchoosepassword3 = /** @type {(inputs: Setupaccountchoosepassword3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a password to complete your account setup.`)
};

const de_setupaccountchoosepassword3 = /** @type {(inputs: Setupaccountchoosepassword3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle ein Passwort, um die Einrichtung deines Kontos abzuschließen.`)
};

/**
* | output |
* | --- |
* | "Choose a password to complete your account setup." |
*
* @param {Setupaccountchoosepassword3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const setupaccountchoosepassword3 = /** @type {((inputs?: Setupaccountchoosepassword3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setupaccountchoosepassword3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_setupaccountchoosepassword3(inputs)
	return de_setupaccountchoosepassword3(inputs)
});
export { setupaccountchoosepassword3 as "setupAccountChoosePassword" }